import React, { Component } from 'react';

export class ArchivosListItem extends Component {

    displayName = ArchivosListItem.name

    archivo() {
        if (this.props.titulo !== "No disponible") {
            if (this.props.ruta.substr(0,13)=="/DocAcervoINN") {
                if (this.props.tipo !== null && this.props.tipo !== undefined){
                    return <span><a href={process.env.REACT_APP_URL_ARCHIVOS + this.props.ruta}  target='_blank' rel="noopener noreferrer"> {this.props.titulo} </a><span> [{this.props.tipo}]</span></span>;
                }else{
                    return <span><a href={process.env.REACT_APP_URL_ARCHIVOS + this.props.ruta}  target='_blank' rel="noopener noreferrer"> {this.props.titulo} </a></span>;
                }
            } else {
                if (this.props.tipo !== null && this.props.tipo !== undefined){
                    return <span><a href={this.props.ruta} target='_blank' rel="noopener noreferrer"> {this.props.titulo}  </a><span> [{this.props.tipo}]</span></span>;
                }else{
                    return <span><a href={this.props.ruta} target='_blank' rel="noopener noreferrer"> {this.props.titulo}  </a></span>;
                }
            }
        } else {
            return "No disponible";
        }
    }

    //
    render() {
        return (
            <div>
                {this.archivo()}
                
            </div>
        );

    }
}
